<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-data-table
        v-if="table.incomeCategories.data.length"
        :loading-text="table.incomeCategories.title"
        :server-items-length="table.incomeCategories.total"
        :loading="table.incomeCategories.loading"
        :headers="table.incomeCategories.headers"
        :items="table.incomeCategories.data"
        :options="table.incomeCategories.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateCategoriesTable"
        class="elevation-1">
        <template v-slot:[`header.cashflowType`]="{ header }">
          <span>{{ header.text }}</span>
          <ButtonHeader
            v-if="expensesPermissions['update-income-type']"
            @click="openAddTypeDialog()"
          >
            <v-icon x-small>mdi-pencil</v-icon>
          </ButtonHeader>
        </template>
        <template v-slot:[`item.cashflowType`]="{ item }">
          <div>{{ (item.concept && item.concept.type) ? item.concept.type.name : undefined }}</div>
        </template>
        <template v-slot:[`header.concept`]="{ header }">
          <span>{{ header.text }}</span>
          <ButtonHeader
            v-if="expensesPermissions['update-income-concept']"
            @click="openAddConceptDialog()"
          >
            <v-icon x-small>mdi-pencil</v-icon>
          </ButtonHeader>
        </template>
        <template v-slot:[`item.concept`]="{ item }">
          <div>{{ item.concept && item.concept.name }}</div>
        </template>
        <template v-slot:[`header.name`]="{ header }">
          <span>{{ header.text }}</span>
          <ButtonHeader
            @click="openAddCategoryDialog()"
          >
            <v-icon x-small>mdi-plus</v-icon>
          </ButtonHeader>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div>{{ item.name }}</div>
        </template>
        <!-- <template v-slot:[`item.includedInCharges`]="{ item }">
          <div>{{ item.includedInCharges ? 'Sí' : 'No' }}</div>
        </template> -->
        <template v-slot:[`item.action`]="{ item }">
          <div>
            <v-btn
              v-if="expensesPermissions['update-income-category']"
              fab
              color="primary"
              x-small
              depressed
              @click="openAddCategoryDialog({
                _id: item._id,
                concept: item.concept ? item.concept._id : '',
                type: (item.concept && item.concept.type) ? item.concept.type._id : '',
                name: item.name
              })"
              class="mr-2"
            >
              <!-- includedInCharges: item.includedInCharges -->
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <div
        v-else
        class="pa-3 grey lighten-4"
        >
        <div class="d-flex justify-center mt-6">
          <v-row
            align="center"
            justify="center">
            <v-icon
              size="150"
              color="primary">
              mdi-cogs
            </v-icon>
            <v-col cols="4">
              <div class="grey--text">
                <div
                  class="title mb-3 font-weight-bold">
                  Aún no tienes cofigurada ninguna categoría de ingreso.
                </div>
                <div class="subtitle-2">
                  <div class="mb-3">
                    Crea alguna para poder tener un control de tus ingresos.
                  </div>
                  <div>
                    <a class="primary--text" href="#" @click.prevent="openAddCategoryDialog()" v-if="expensesPermissions['create-income-category']">Crear una categoría de ingreso</a>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-flex>

    <AddCategory
      ref="addCategory"
      @updated="loadCategories"
    />

    <AddIncomeConcept
      ref="addConcept"
      @updated="loadCategories"
    />

    <AddIncomeType
      ref="addType"
      @updated="loadCategories"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddCategory from '@/components/modals/AddIncomeCategory'
import AddIncomeConcept from '@/components/modals/AddIncomeConcept'
import AddIncomeType from '@/components/modals/AddIncomeType'
import ButtonHeader from '@/components/elements/ButtonHeader'

export default {
  name: 'IncomeCategories',
  components: {
    AddCategory,
    AddIncomeConcept,
    AddIncomeType,
    ButtonHeader
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.incomeCategories.section'),
      table: {
        incomeCategories: {
          title: this.$i18n.t('expenses.incomeCategories.tableIncomeCategories.loadingText'),
          loading: true,
          headers: [
            { text: this.$i18n.t('expenses.incomeCategories.tableIncomeCategories.headers.type'), value: 'cashflowType' },
            { text: this.$i18n.t('expenses.incomeCategories.tableIncomeCategories.headers.concept'), value: 'concept' },
            { text: this.$i18n.t('expenses.incomeCategories.tableIncomeCategories.headers.category'), value: 'name' },
            // { text: this.$i18n.t('expenses.incomeCategories.tableIncomeCategories.headers.includedInCharges'), value: 'includedInCharges' },
            { text: '', value: 'action' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        }
      },
      tab: 0,
      search: ''
    }
  },
  watch: {
    restaurant: {
      handler: async function () {
        await this.loadCategories()
      },
      deep: true
    }
  },
  computed: {
    expensesPermissions () {
      return this.$store.state.login.permissions['expenses'].components['income-category'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  async mounted () {
    await this.loadCategories({
      type: 'income',
      restaurant: this.$store.state.currentRestaurant.data._id
    })
  },
  methods: {
    openAddCategoryDialog: function (item) {
      this.$refs.addCategory.openDialog(item)
    },
    updateCategoriesTable: async function (data) {
      this.table.incomeCategories.options = data
      if (this.$store.state.area) {
        await this.loadCategories({
          type: 'income',
          restaurant: this.$store.state.currentRestaurant.data._id,
          sort: data.sortDesc[0] ? data.sortBy[0] : `-${data.sortBy[0] || 'name'}`,
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1))
        })
      }
    },
    async loadCategories (params = null) {
      params = params || {
        type: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.table.incomeCategories.loading = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.table.incomeCategories.data = response.data
        this.table.incomeCategories.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.incomeCategories.loading = false
    },
    openAddConceptDialog (concept) {
      this.$refs.addConcept.openDialog(concept)
    },
    openAddTypeDialog (type) {
      this.$refs.addType.openDialog(type)
    }
  }
}
</script>
